import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DashboardComponent } from './dashboard/dashboard.component';
import { AccountComponent } from './account/account.component';
import { ApiIntegrationComponent } from './api-integration/api-integration.component';
import { BillingComponent } from './billing/billing.component';
import { TemplatesComponent } from './templates/templates.component';
import { S3StorageComponent } from './s3-storage/s3-storage.component';
import { eStampActiveGuard } from '../core/guards/estamp.guard';

const routes: Routes = [
    { path: 'dashboard', component: DashboardComponent },
    { path: 'account', component: AccountComponent },
    { path: 'api-integration', component: ApiIntegrationComponent },
    { path: 'billing', component: BillingComponent },
    { path: 'templates', component: TemplatesComponent },
    { path: 's3-storage', component: S3StorageComponent },
    { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
    { path: 'esign', loadChildren: () => import('./e-sign/e-sign.module').then(m => m.ESignModule) },
    { path: 'estamp', loadChildren: () => import('./e-stamp/e-stamp.module').then(m => m.EStampModule) },



];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class PagesRoutingModule { }
